import defaults from '@config/defaults'
import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    marginBottom: ({ offset }) => `${offset}px`,
    [theme.breakpoints.down('xs')]: {
      marginBottom: ({ offset }) => `${offset + 150}px`,
    },
  },
  imageContainer: ({ images }) => ({
    backgroundImage: images && `url(${images.lg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    height: `calc(100vh - ${defaults.redesignHeaderHeight * 2}px)`,
    [theme.breakpoints.down('xs')]: {
      backgroundImage: images && `url(${images.sm})`,
    },
  }),
  heroBlock: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: ({ offset }) => `-${offset}px`,
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      bottom: ({ offset }) => `-${offset + 150}px`,
    },
  },
  contentWrapper: {
    width: '80%',
    minWidth: '850px',
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.secondary.dark,
    padding: theme.spacing(6),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
      width: '100%',
      position: 'relative',
      flexDirection: 'column',
      height: 'auto',
      alignItems: 'stretch',
      justifyContent: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      justifyContent: 'center',
      height: 'auto',
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  headlineContainer: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: 0,
      paddingBottom: theme.spacing(4),
    },
  },
  breadcrumbs: {
    marginBottom: theme.spacing(3),
    color: 'white',
    '&>ol': {
      '&>li': {
        color: 'white !important',
        '&:last-child>a': {
          cursor: 'default',
        },
        '&:not(:last-child):hover': {
          textDecoration: 'underline !important',
        },
        '&>a': {
          color: 'white',
          fontSize: '0.875rem',
        },
      },
    },
  },
  headline: {
    color: theme.palette.primary.contrastText,
    marginBottom: theme.spacing(3),
    '&:hover': {
      color: theme.palette.primary.contrastText,
    },
  },
  ctaContainer: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    borderLeft: '1px solid white',
    padding: theme.spacing(3),
    paddingLeft: theme.spacing(6),
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: 0,
      paddingTop: theme.spacing(4),
      border: 'none',
      borderTop: '1px solid white',
    },
  },
  ctaInnerContainer: {},
  ctaHeadline: {
    marginBottom: theme.spacing(3),
  },
  ctaButtonWrapper: {
    marginBottom: theme.spacing(3),
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
  ctaDescription: {
    display: 'inline',
  },
  ctaLink: {
    color: theme.palette.primary.contrastText,
    padding: 0,
    paddingLeft: theme.spacing(1),
    height: 'auto',
    '&:hover': {
      color: theme.palette.primary.contrastText,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'flex-start',
      padding: 0,
      paddingTop: theme.spacing(1),
    },
  },
  ctaButton: {
    ...theme.typography.formTags,
    textAlign: 'center',
    borderRadius: '8px',
    whiteSpace: 'nowrap',
    fontSize: '0.875rem',
    transition: '250ms',
    backgroundColor: 'transparent',
    color: theme.palette.primary.contrastText,
    textDecoration: 'none',
    [theme.breakpoints.down('xs')]: {
      ...theme.typography.formLabel,
      flexShrink: '0',
      fontSize: '12px',
    },
    '&:hover, &:active': {
      textDecoration: 'none',
      backgroundColor: theme.palette.offwhite.main,
      color: theme.palette.blue.dark,
    },
  },
  active: {
    backgroundColor: theme.palette.offwhite.main,
    color: theme.palette.blue.main,
    '&:hover': {
      backgroundColor: theme.palette.offwhite.main,
      color: theme.palette.blue.main,
    },
  },
}))
